import { render, staticRenderFns } from "./ShowSingleList.vue?vue&type=template&id=4823597d&scoped=true&"
import script from "./ShowSingleList.vue?vue&type=script&lang=ts&"
export * from "./ShowSingleList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4823597d",
  null
  
)

export default component.exports